import * as React from 'react'
import { Route, Link } from 'react-router-dom';


interface ISystemBreadCrumb {
    match: any,
}

const Breadcrumbs = (props: ISystemBreadCrumb) => {

    let route = '';

    let pathUrl = [];

    const formatPath = (path: string) => path.replaceAll("-", " ").replaceAll("/", "");

    for (let index = 0; index < route.length; index++) {
        var path = route[index].location.pathname;

        var searchParam = route[index].location.search;

        if (index == route.length - 1) {
            pathUrl.push(<><a>{formatPath(path)}</a></>)
        }
        else if (formatPath(path).trim()) {
            pathUrl.push(<><Link to={path + searchParam}>{formatPath(path)}</Link> <span> / </span></>)
        }
    }

    return (
        <li id={Math.random().toString()} className={props.match.isExact ? 'breadcrumb-item active' : 'breadcrumb-item'}>
            <span>
                {pathUrl}
            </span>
        </li>
    )
}

export const SystemBreadCrumb = () =>
    <ol className="breadcrumb mb-0 px-0">
        <li className="breadcrumb-item"><a href="" target="_self" >Home</a></li>
        <Route path='/:path' component={Breadcrumbs} />
    </ol>